import { render } from "./SvgSprite.vue?vue&type=template&id=10f8b2ec&ts=true"
import script from "./SvgSprite.vue?vue&type=script&lang=ts"
export * from "./SvgSprite.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_3adea55ba6ae913f8a015974add4e384/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__